<template>
    <div>
        <label :for="id">{{ label }}</label>
        <input :id="id" type="checkbox" v-model="localModel" @change="e => $emit('updateValue', e.target.checked)" />
    </div>
</template>

<script>
import { createUUID } from "@/utils/string";
export default {
    data: () => ({
        id: createUUID(),
        localModel: undefined
    }),
    model: {
        prop: "model",
        event: "updateValue"
    },
    props: {
        label: {
            type: String,
            required: true
        },
        model: {
            required: true
        }
    },
    created() {
        this.localModel = this.model;
    }
};
</script>

<style scoped lang="scss">
div {
    display: flex;
    justify-content: space-between;
    margin: 3px 0px;
    > * {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// CheckBox.vue?0b321678